<div class="flex flex-wrap items-center gap-3">
  <button
    mat-button
    class="button-general-border flex gap-2 items-center justify-center font-medium"
    (click)="openQuotationPDFDialog()"
    [disabled]="!activeQuotationPDF"
  >
    <mat-icon>picture_as_pdf</mat-icon>
    {{ 'quotation.fieldNames.quotation' | translate }}: {{ quotationId }}
  </button>
  <div class="font-medium text-xl text-(--color-text-title)">
    {{ 'quotation.sticky-toolbar.addExtras' | translate }}
  </div>
  <button
    mat-button
    class="button-general-border flex gap-2 items-center justify-center font-medium"
    (click)="openFormalitysDialog()"
  >
    <mat-icon>assignment</mat-icon>
    {{ 'quotation.sticky-toolbar.procedures' | translate }}
    <!-- src="assets/icons/icon_tramites_blanco.svg" -->
  </button>
  <button
    mat-button
    class="button-general-border flex gap-2 items-center justify-center font-medium"
    (click)="openAccessoriesDialog()"
  >
    <mat-icon>filter_tilt_shift</mat-icon>
    {{ 'quotation.sticky-toolbar.accessories' | translate }}
  </button>
  @if (
    comparativeData &&
    comparativeData.quotationComparatives &&
    comparativeData.quotationComparatives.length &&
    activeQuotationPDF
  ) {
    <button
      mat-button
      class="button-general-border flex gap-2 items-center justify-center font-medium"
      (click)="sendEmail()"
    >
      <!-- src="assets/icons/icon_enviar_documentos_blanco.svg"  -->
      <mat-icon>email</mat-icon>
      {{ 'quotation.sticky-toolbar.sendEmail' | translate }}
    </button>
  }
  <!-- @if () {
    <button
      mat-button
      class="button-general-border flex gap-2 items-center font-medium"

    >


      {{ 'quotation.fieldNames.ticketsPDF' | translate }}
    </button>
  } -->
</div>

<div class="flex items-center gap-3"></div>
